module.exports = __webpack_public_path__ + "static/media/barcode_scan.31aa4cfd.svg";